
export interface ILangMessages {
  [key: number]: {
    [key: string]: string
  }
}

export class LangMessages {
  public static DEFAULT: ILangMessages = {
    39: {
      'general.undo': 'Annulla',
      'general.confirm': 'Conferma',
      'general.functions': 'Funzioni',
      'general.xact_info': 'Info Scontrino',
      'general.no_xact_info': 'Nessuna info scontrino.',
      'general.xact_messages': 'Messaggi',
      'general.applied_discount': 'Sconto Applicato',
      'general.gui_options': 'Opzioni GUI',
      'general.left_hand_use': 'Uso Mancino',
      'general.enable_sound': 'Abilita Effetti Sonori',
      'general.enable_speech': 'Abilita Voce',
      'general.suspended_cart': 'Carrello in Sospeso',
      'general.suspended_cart_message':
        'Sono stati rilevati prodotti in sospeso nel carrello. Vuoi recuperarli?',
      'auth.login': 'Accedi',
      'auth.username': 'Operatore',
      'auth.password': 'Password',
      'auth.sam_address': 'SAM',
      'auth.store_id': 'ID Negozio',
      'auth.device_id': 'ID Dispositivo',
      'auth.device_type': 'Tipo Dispositivo',
      'auth.update_notice':
        'Aggiornamento Disponibile! Effetturare il Riavvio.',
      'auth.update_now': 'Aggiorna Ora',
      'cart.empty_notice': 'Carrello Vuoto',
      'fidelity.request': 'Passare Tessera',
      'jhim.scanner.connected': 'Scanner Barcode collegato!',
      'jhim.scanner.disconnected': 'Scanner Barcode scollegato!',
      'declaration.period': 'Periodo',
      'declaration.total': 'Totale',
      'declaration.expected_total': 'Totale Atteso',
      'general.finish_and_pay': 'Termina e Paga',
      "general.package": "Confezione",
    },
    44: {
      'general.undo': 'Undo',
      'general.confirm': 'Confirm',
      'general.functions': 'Functions',
      'general.xact_info': 'Receipt Info',
      'general.no_xact_info': 'Receipt Info empty.',
      'general.xact_messages': 'Messages',
      'general.applied_discount': 'Applied Discounts',
      'general.gui_options': 'GUI Options',
      'general.left_hand_use': 'Left Hand Use',
      'general.enable_sound': 'Enable Sounds',
      'general.enable_speech': 'Enable Speech',
      'general.suspended_cart': 'Cart Pending',
      'general.suspended_cart_message':
        'Pending products were found in the Cart. Do you want to recover them?',
      'auth.login': 'Login',
      'auth.username': 'Operator',
      'auth.password': 'Password',
      'auth.sam_address': 'SAM',
      'auth.store_id': 'Store ID',
      'auth.device_id': 'Device ID',
      'auth.device_type': 'Device Type',
      'auth.update_notice': 'Update Available! Please Reboot now.',
      'auth.update_now': 'Update Now',
      'cart.empty_notice': 'Empty Cart',
      'fidelity.request': 'Scan Fidelity',
      'jhim.scanner.connected': 'Barcode Scanner connected!',
      'jhim.scanner.disconnected': 'Barcode Scanner disconnected!',
      'declaration.period': 'Period',
      'declaration.total': 'Total',
      'declaration.expected_total': 'Expected Total',
      'general.finish_and_pay': 'Finish and Pay',
      "general.package": "Package",
    },
  };

  public static getMessages(lang: number) {
    if (LangMessages.DEFAULT[lang]) {
      return LangMessages.DEFAULT[lang];
    } else {
      return LangMessages.DEFAULT[44];
    }
  }
}
